import type { Config } from 'mixpanel-browser';

import { getUrl } from 'utils/api';

const isProduction = process.env.VITE_DEPLOY_ENV === 'production';

export type MixpanelInitConfig = Partial<Config> & {
  record_heatmap_data: boolean;
};

export function getMixpanelConfig(useProxy: boolean): MixpanelInitConfig {
  const config: MixpanelInitConfig = {
    debug: !isProduction,
    ignore_dnt: true,
    track_pageview: isProduction,
    persistence: 'localStorage',
    record_sessions_percent: isProduction ? 100 : 0, // records 100% of all sessions
    record_heatmap_data: isProduction,
  };

  if (!useProxy) {
    return config;
  }

  return {
    ...config,
    api_host: getUrl('/mixpanel', 'v2'),
    api_payload_format: 'json',
  };
}
